import get from 'lodash/get';
import alertMutations, {
	getErrorMessage,
	formatAlert,
} from 'optinmonster-js-library/src/vue/campaigns/store/alerts/mutations';
import { objects, hasAuthError } from '@/utils';

const maybeAddMeta = function (payload) {
	const code = String(get(payload, 'response.body.code'));
	if ('omapp_wrong_site' === code) {
		payload = {
			closes: false,
			explanation: '<span class="omapi-alert__primary">Site Error, Action Required:</span><br>',
			message: get(payload, 'response.body.message', {}),
			meta: get(payload, 'response.body.data.site', {}),
		};
		payload.meta.verifySiteChange = true;
	}

	if (hasAuthError(payload)) {
		payload = {
			closes: false,
			explanation: '<span class="omapi-alert__primary">Authentication Error, Action Required:</span><br>',
			message: get(payload, 'response.body.message', {}),
			meta: {
				badCredentials: true,
			},
		};
	}

	return payload;
};

const clonedMutations = { ...alertMutations };

clonedMutations.maybeAddError = function (state, payload) {
	alertMutations.maybeAddError(state, maybeAddMeta.call(this, payload));
};

clonedMutations.setError = function (state, payload) {
	clonedMutations.maybeAddError(state, payload);
	state.error = true;
};

clonedMutations.maybeRemoveAlert = function (state, payload) {
	const alertIndex = state.alerts.findIndex((a) => {
		return objects.areEqual(a, payload);
	});

	if (-1 !== alertIndex) {
		clonedMutations.closeAlert.call(this, state, alertIndex);
	}
};

export { getErrorMessage, formatAlert };

export default clonedMutations;
